import { render, staticRenderFns } from "./role-menu-detail.vue?vue&type=template&id=f7656930&scoped=true&"
import script from "./role-menu-detail.vue?vue&type=script&lang=js&"
export * from "./role-menu-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7656930",
  null
  
)

export default component.exports